import React from 'react'
import HomeBanner from './home/HomeBanner'
import HomeAbout from './home/HomeAbout'
import MissionVision from './home/MissionVision'
import HomeWorkingProcess from './home/HomeWorkingProcess'
import OurDepartments from './home/OurDepartments'
import HomeFaq from './home/HomeFaq'
import HomeTestimonials from './home/HomeTestimonials'
import OurFacilites from './home/OurFacilites'
import OutTeam from './home/OutTeam'
import HomeBlog from './home/HomeBlog'
import PressRelease from './home/PressRelease'
import DepartmentsHome from './home/DepartmentsHome'



const Home = () => {
  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <HomeBanner />
        <DepartmentsHome />
        <PressRelease />
        <OurDepartments />
        <HomeAbout />
        {/* <OutTeam /> */}
        <HomeFaq />
        <HomeTestimonials />
        <MissionVision />
        {/* <HomeWorkingProcess /> */}
        <OurFacilites />
        <HomeBlog />
      </div>






    </>
  )
}

export default Home